/**
 * App Config File
 */

export default {
  appLogo: '/static/img/site-logo.png',
  copyrightText: 'Vuely © 2019 All Rights Reserved.',
  enableUserTour: process.env.NODE_ENV === 'production',
  nombreApp: process.env.VUE_APP_NOMBRE_APP,
  urlServer: process.env.VUE_APP_URL_SERVER,
  urlApi: process.env.VUE_APP_URL_API,
  logoAsociacion: '/static/img/logo_asociacion.jpg'
}
